import { isInsightsEnabled } from '@/helpers/featureFlags'

// Insights is new-design only and behind the PostHog `Insights` flag (see isInsightsEnabled); a link or a typed
// URL lands on Home instead.
const insightsGuard = () => (isInsightsEnabled() ? true : '/')

export default [
  {
    path: '/insights',
    name: 'Insights',
    meta: {
      requireAuth: true,
      requireFields: true,
    },
    component: () => import('@/views/Insights/index.vue'),
    beforeEnter: insightsGuard,
  },
  {
    // `/insights/{report slug}/{insight slug}` — the API's own slugs, so a card's CTA (`cta_url`) lands here as
    // is. Any slug matches: the report page asks the API, shows its "not found" for an unknown report, and
    // sends a missing or unknown tab to the report's first one.
    path: '/insights/:reportSlug/:insightSlug?',
    name: 'InsightsReport',
    meta: {
      requireAuth: true,
      requireFields: true,
    },
    component: () => import('@/views/InsightsReport/index.vue'),
    beforeEnter: insightsGuard,
  },
]
